import React from 'react';
import { Link } from 'react-router-dom';
import SimplePage, { Card } from '../components/SimplePage';

const TOPICS = [
  {
    q: 'How do I check a link, file or IP address?',
    a: 'In the iPhone app, open the Scanner tab (or "Threat Intelligence" on the web dashboard), choose File, URL or IP, and run the check. Results show which service flagged what. "Couldn\'t check" means a service couldn\'t be reached; try again later.',
  },
  {
    q: 'What does "No threats found" mean?',
    a: 'None of the services we check (VirusTotal, Google Safe Browsing, PhishTank or AbuseIPDB) know of a problem. That\'s a good sign, but no service can guarantee something is safe. Be cautious with anything asking for money, passwords or codes.',
  },
  {
    q: 'Is it safe to check private files?',
    a: 'Files VirusTotal hasn\'t seen before are uploaded to VirusTotal, which shares submissions with security researchers. Don\'t check private or confidential documents.',
  },
  {
    q: 'How do I set up Email Protection?',
    a: 'Open Protection → Email Protection, choose Gmail, Outlook or Yahoo, and sign in. CyberGuard gets read-only access: it can flag emails with dangerous links or attachments, but it never deletes or moves your email.',
  },
  {
    q: 'Can CyberGuard tell if my iPhone has spyware?',
    a: 'No. iOS keeps every app separate, so no app can scan your iPhone for spyware. The app\'s Privacy Checkup walks you through Apple\'s own tools instead, including Safety Check (Settings → Privacy & Security → Safety Check). If you\'re worried about your safety, Apple\'s Personal Safety guide is at support.apple.com/guide/personal-safety. In an emergency, contact local emergency services.',
  },
  {
    q: 'How do I install Desktop Protection?',
    a: 'In the app, open Protection → Desktop Protection and tap "Get registration code". Then on your computer, follow the steps at cyberguardglobal.com/download and enter the code when asked.',
  },
  {
    q: 'How do I cancel my subscription?',
    a: 'Subscriptions bought in the iPhone app are managed by Apple: Settings → [your name] → Subscriptions. For subscriptions bought on our website, email team@cyberguardglobal.com.',
  },
  {
    q: 'How do I delete my account?',
    a: 'In the iPhone app: Profile → Delete Account. On the web: Dashboard → Account → Delete Account. This removes your account and its data.',
  },
];

const HelpCenter = () => (
  <SimplePage title="Help Center" subtitle="Answers to common questions">
    {TOPICS.map(t => (
      <Card key={t.q} title={t.q}>
        <p>{t.a}</p>
      </Card>
    ))}
    <Card title="Still need help?">
      <p>
        Email <a href="mailto:team@cyberguardglobal.com" className="text-cyan-400 hover:underline">team@cyberguardglobal.com</a> or
        use the <Link to="/contact" className="text-cyan-400 hover:underline">contact form</Link>.
      </p>
    </Card>
  </SimplePage>
);

export default HelpCenter;
